// Animation wrapper (anime.js) -----------------------------
import anime from 'animejs'
const DEFAULT_EASE = 'easeOutQuad';


let t = {
    anim (targets, duration, props, easing = DEFAULT_EASE) {
        anime(Object.assign(props, { targets, easing, duration }));
    },
    fadeTo (targets, duration = 600, opacity, options) {
        anime($.extend({ targets, duration, opacity, easing: DEFAULT_EASE }, options));
    },
    fadeIn (targets, duration = 600, options) {
        Z.fadeTo(targets, duration, 1, options);
    },
    fadeOut (targets, duration = 600, options) {
        Z.fadeTo(targets, duration, 0, options);
    },
    fadeOutRemove (targets, duration = 600, options) {
        Z.fadeTo(targets, duration, 0, $.extend({ complete: () => targets.remove() }, options));
    },
    // animating scroll
    scrollTo (y, duration = 500, easing = DEFAULT_EASE) {
        const scrollCoords = { y: Z.scrollY };
        anime({
            targets: scrollCoords, y, duration, easing,
            update: () => window.scrollTo(0, scrollCoords.y)
        })
    },
    scrollToElement (el, duration = 500, offset = 0, ease = DEFAULT_EASE) {
        Z.scrollTo(el.getBoundingClientRect().y + Z.vh + offset, duration, ease);
    },
};

window.ANIM = t;

